import { useLocation } from "react-router-dom";
import "url-search-params-polyfill";

export function useUrlQuery() {
  const location = useLocation();

  return new URLSearchParams(location.search);
}
